<template>
  <div>
    <!-- حوار تأكيد التصدير -->
    <v-dialog width="400" v-model="verify">
      <v-card>
        <v-card-text>
          <v-icon size="large" color="warning" class="d-flex justify-center mb-4">mdi-alert-circle-outline</v-icon>
          <h3 class="text-center font-weight-bold">هل أنت متأكد من تصدير البيانات؟</h3>
          <p class="text-center text-caption text-medium-emphasis mt-2">
            سيتم تصدير {{ selectedVendors.length }} منفذ
          </p>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-row justify="center" class="py-3">
            <v-col cols="auto">
              <v-btn variant="elevated" color="success" @click="exportToExcel" :loading="exportLoading">
                <v-icon start>mdi-check</v-icon>
                <span>موافق</span>
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn variant="outlined" color="grey-darken-1" @click="verify = false">
                <v-icon start>mdi-close</v-icon>
                <span>إلغاء</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- حوار عرض الصور -->
    <v-dialog width="500" v-model="show_images">
      <v-card>
        <v-card-title class="bg-primary">
          <v-icon color="white" class="ml-2">mdi-store</v-icon>
          <span class="text-white">{{ target_item.vendor_name }}</span>
          <v-spacer />
          <v-btn icon @click="show_images = false" variant="text" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <v-row>
            <v-col v-for="(image, index) in imageLinks" :key="index" cols="12" md="6">
              <v-card variant="outlined" class="h-100">
                <v-card-text class="text-center pa-3">
                  <v-icon size="large" color="indigo" class="mb-2">mdi-image</v-icon>
                  <div>
                    <a :href="image.url" target="_blank" class="text-decoration-none text-indigo-darken-3">
                      {{ image.title }}
                    </a>
                  </div>
                  <v-chip size="small" color="indigo-lighten-5" class="mt-2">
                    <v-icon size="small" class="ml-1">mdi-eye</v-icon>
                    عرض الصورة
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-btn block variant="outlined" @click="show_images = false">
            <v-icon start>mdi-close</v-icon>
            إغلاق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- البطاقة الرئيسية -->
    <v-card class="h-screen d-flex flex-column">
      <v-card-title class="bg-primary pa-4">
        <v-row align="center" no-gutters>
          <v-col cols="auto">
            <v-icon color="white" size="28">mdi-store-marker</v-icon>
            <span class="mr-2 text-h6 text-white font-weight-bold">طلبات تسجيل المنافذ</span>
          </v-col>
          <v-spacer />
          <v-col cols="auto">
            <v-btn variant="elevated" color="white" @click="logout" :loading="logoutLoading">
              <v-icon start>mdi-logout</v-icon>
              <span>تسجيل خروج</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>

      <v-divider />

      <!-- أدوات التحكم -->
      <v-card-text class="pa-4">
        <v-row align="center">
          <!-- عمود التصدير -->
          <v-col cols="12" md="3">
            <v-card variant="outlined" class="pa-2">
              <v-row align="center">
                <v-col cols="6">
                  <v-btn 
                    block 
                    variant="elevated" 
                    color="green" 
                    @click="verify = true"
                    :disabled="selectedVendors.length === 0"
                    prepend-icon="mdi-microsoft-excel"
                  >
                    تصدير
                  </v-btn>
                </v-col>
                <v-col cols="6">
                  <v-switch
                    v-model="all"
                    @change="get_vendors"
                    label="عرض الكل"
                    color="primary"
                    density="compact"
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- عمود فلترة المحافظة -->
          <v-col cols="12" md="3">
            <v-autocomplete
              v-model="searchGovernorate"
              :items="governorates"
              label="فلترة بالمحافظة"
              variant="outlined"
              density="compact"
              clearable
              prepend-inner-icon="mdi-filter"
              hide-details
            />
          </v-col>

          <!-- عمود فلترة التاريخ -->
          <v-col cols="12" md="4">
            <v-card variant="outlined" class="pa-3">
              <v-row dense align="center">
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="from"
                    label="من تاريخ"
                    type="date"
                    density="compact"
                    variant="outlined"
                    hide-details
                    prepend-inner-icon="mdi-calendar-start"
                  />
                </v-col>
                <v-col cols="12" md="5">
                  <v-text-field
                    v-model="to"
                    label="إلى تاريخ"
                    type="date"
                    density="compact"
                    variant="outlined"
                    hide-details
                    prepend-inner-icon="mdi-calendar-end"
                  />
                </v-col>
                <v-col cols="12" md="2">
                  <v-btn
                    block
                    color="primary"
                    @click="get_vendors_by_dates"
                    variant="elevated"
                    density="compact"
                    :disabled="!from || !to"
                  >
                    <v-icon>mdi-filter</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-col>

          <!-- عمود البحث -->
          <v-col cols="12" md="2">
            <v-text-field
              v-model="searchQuery"
              label="بحث باسم المنفذ أو المالك"
              variant="outlined"
              density="compact"
              clearable
              prepend-inner-icon="mdi-magnify"
              hide-details
              @keyup.enter="searchVendors"
            />
          </v-col>
        </v-row>

        <!-- معلومات التحديد -->
        <v-alert v-if="selectedVendors.length > 0" type="info" density="compact" class="mt-3">
          <v-row align="center">
            <v-col>
              <span>تم تحديد {{ selectedVendors.length }} منفذ</span>
            </v-col>
            <v-col cols="auto">
              <v-btn size="small" variant="text" @click="selectedVendors = []">
                إلغاء التحديد
              </v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-card-text>

      <v-divider />

      <!-- محتوى الجدول -->
      <v-card-text class="flex-grow-1 pa-0">
        <!-- حالة التحميل -->
        <div v-if="loading" class="d-flex align-center justify-center" style="height: 400px">
          <div class="text-center">
            <v-progress-circular indeterminate color="primary" size="50" />
            <p class="mt-4 text-medium-emphasis">جاري تحميل البيانات...</p>
          </div>
        </div>

        <!-- الجدول -->
        <div v-else>
    <v-data-table
  v-model="selectedVendors"
  :headers="headers"
  :items="filteredVendors"
  :search="searchQuery"
  :items-per-page="itemsPerPage"
  :page="currentPage"
  items-per-page-text=""
  show-select
  item-value="vendor_id"
  fixed-header
  height="600px"
  @update:page="currentPage = $event"
  @update:items-per-page="itemsPerPage = $event"
>

            <!-- رأس الجدول
            <template #header.data-table-select>
              <v-checkbox
                v-model="selectAll"
                @change="toggleSelectAll"
                hide-details
                density="compact"
                color="primary"
              />
            </template> -->

            <!-- خلايا مخصصة -->
            <template #[`item.vendor_name`]="{ item }">
              <div class="font-weight-medium">{{ item.vendor_name }}</div>
            </template>

            <template #[`item.vendor_address`]="{ item }">
              <a
                :href="'https://maps.google.com/maps?q=' + item.lat + ',' + item.lng"
                target="_blank"
                class="d-flex align-center text-decoration-none text-primary"
              >
                <v-icon small class="ml-1">mdi-map-marker</v-icon>
                <span class="text-truncate" style="max-width: 150px">{{ item.vendor_address }}</span>
              </a>
            </template>

            <template #[`item.pc`]="{ item }">
              <v-chip
                :color="fdevice(item.pc) ? 'green' : 'red'"
                size="small"
                variant="flat"
              >
                <v-icon start small>{{ fdevice(item.pc) ? 'mdi-check' : 'mdi-close' }}</v-icon>
                {{ fdevice(item.pc) ? 'نعم' : 'لا' }}
              </v-chip>
            </template>

            <template #[`item.futronic`]="{ item }">
              <v-chip
                :color="fdevice(item.futronic) ? 'green' : 'red'"
                size="small"
                variant="flat"
              >
                <v-icon start small>{{ fdevice(item.futronic) ? 'mdi-check' : 'mdi-close' }}</v-icon>
                {{ fdevice(item.futronic) ? 'نعم' : 'لا' }}
              </v-chip>
            </template>

            <template #[`item.created_at`]="{ item }">
              {{ formatDate(item.created_at) }}
            </template>

            <template #[`item.actions`]="{ item }">
              <v-row no-gutters>
                <v-col cols="6">
                  <v-tooltip text="عرض الصور">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        size="small"
                        variant="text"
                        color="info"
                        @click="set_images(item)"
                      >
                        <v-icon>mdi-image-multiple</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </v-col>
                <v-col cols="6" >
                  <v-tooltip :text="item.printed == 1 ? 'تم الطباعة' : 'طباعة'">
                    <template #activator="{ props }">
                      <v-btn
                        v-bind="props"
                        icon
                        size="small"
                        variant="text"
                        :color="item.printed == 1 ? 'success' : 'primary'"
                        @click="setVendorToReport(item)"
                      >
                        <v-icon>{{ item.printed == 1 ? 'mdi-printer-check' : 'mdi-printer' }}</v-icon>
                      </v-btn>
                    </template>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>

            <!-- رسالة عدم وجود بيانات -->
            <template #no-data>
              <div class="py-8 text-center">
                <v-icon size="64" color="grey-lighten-1">mdi-database-off</v-icon>
                <p class="mt-4 text-h6 text-grey">لا توجد بيانات</p>
                <p class="text-caption text-grey">لم يتم العثور على أي منافذ تطابق معايير البحث</p>
              </div>
            </template>
          </v-data-table>

        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "VendorsList",
  data() {
    return {
      loading: false,
      exportLoading: false,
      logoutLoading: false,
      vendors: [], // تهيئة كمصفوفة فارغة
      searchQuery: "",
      searchGovernorate: "",
      selectedVendors: [],
      selectAll: false,
      verify: false,
      all: false,
      show_images: false,
      from: "",
      to: "",
      
      // إعدادات الترقيم
      currentPage: 1,
      itemsPerPage: 10,
      
      // بيانات الصور
      target_item: {
        vendor_name: "",
        master: "",
        certificate: "",
        id_front: "",
        id_back: "",
        res_front: "",
        res_back: "",
        doc1:"",
        doc2:"",
        doc3:""
      },
      
      // المحافظات
      governorates: [
        "بغداد", "كربلاء", "النجف", "بابل", "القادسية",
        "المثنى", "ذي قار", "ميسان", "البصرة", "واسط",
        "ديالى", "كركوك", "نينوى", "صلاح الدين", "الأنبار",
        "دهوك", "أربيل", "السليمانية"
      ],
      
      // عناوين الجدول
      headers: [
        { title: "التحديد", key: "data-table-select", sortable: false, width: "50px" },
        { title: "ت", key: "index", width: "50px", sortable: false },
        { title: "المنفذ", key: "vendor_name", width: "150px" },
        { title: "المالك", key: "vendor_owner", width: "120px" },
        { title: "المحافظة", key: "governorate", width: "100px" },
        { title: "القضاء", key: "district", width: "100px" },
        { title: "الناحية", key: "subdistrict", width: "100px" },
        { title: "أقرب نقطة", key: "nearest", width: "100px" },
        { title: "العنوان", key: "vendor_address", width: "200px" },
        { title: "الهاتف", key: "vendor_phone", width: "120px" },
        { title: "رقم الحساب", key: "vendor_owner_account_number", width: "120px" },
        { title: "IBAN", key: "iban", width: "150px" },
        { title: "لابتوب", key: "pc", width: "80px" },
        { title: "البصمة", key: "futronic", width: "80px" },
        { title: "تاريخ التقديم", key: "created_at", width: "120px" },
        { title: "الإجراءات", key: "actions", sortable: false, width: "100px"  }
      ]
    };
  },
  computed: {
    // فلترة البيانات
    filteredVendors() {
      // التحقق من أن vendors مصفوفة
      if (!Array.isArray(this.vendors)) {
        console.error('vendors is not an array:', this.vendors);
        return [];
      }
      
      let filtered = [...this.vendors];
      
      // فلترة بالمحافظة
      if (this.searchGovernorate) {
        filtered = filtered.filter(
          v => v.governorate === this.searchGovernorate
        );
      }
      
      // فلترة بالبحث النصي
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        filtered = filtered.filter(v =>
          (v.vendor_name || "").toLowerCase().includes(query) ||
          (v.vendor_owner || "").toLowerCase().includes(query) ||
          (v.vendor_phone || "").toLowerCase().includes(query) ||
          (v.iban || "").toLowerCase().includes(query)
        );
      }
      
      // إضافة الفهرس
      return filtered.map((item, index) => ({
        ...item,
        index: index + 1
      }));
    },
    
    // البيانات المترقمة
    paginatedVendors() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredVendors.slice(start, end);
    },
    
    // روابط الصور
    imageLinks() {
      const baseUrl = 'https://hfd.gov.iq/backend/public/';
      return [
        { title: 'الماستر', url: baseUrl + this.target_item.master },
        { title: 'الإجازة', url: baseUrl + this.target_item.certificate },
        { title: 'وجه الموحدة', url: baseUrl + this.target_item.id_front },
        { title: 'ظهر الموحدة', url: baseUrl + this.target_item.id_back },
        { title: 'وجه السكن', url: baseUrl + this.target_item.res_front },
        { title: 'ظهر السكن', url: baseUrl + this.target_item.res_back },
        { title: 'صفحة التعهد الاولى', url: baseUrl + this.target_item.doc1 },
        { title: 'صفحة التعهد الثانية', url: baseUrl + this.target_item.doc2 },
        { title: 'كشف الحساب', url: baseUrl + this.target_item.doc3 },

      ].filter(img => img.url !== baseUrl && img.url !== baseUrl + 'undefined');
    },
    
    // مؤشرات الترقيم
    startIndex() {
      return (this.currentPage - 1) * this.itemsPerPage;
    },
    
    endIndex() {
      const end = this.startIndex + this.itemsPerPage;
      return end > this.filteredVendors.length ? this.filteredVendors.length : end;
    }
  },
  watch: {
    // إعادة تعيين الترقيم عند تغيير البحث
    searchQuery() {
      this.currentPage = 1;
    },
    
    searchGovernorate() {
      this.currentPage = 1;
    }
  },
  methods: {
    // تحميل المنافذ
    async get_vendors() {
      this.loading = true;
      const token = localStorage.getItem("token");
      
      try {
        const url = this.all 
          ? "api/admin/904195-get-all-vendors"
          : "api/admin/904195-get-vendors";
        
        const response = await this.$axios.get(url, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        // التحقق من استجابة الـ API
        if (response.data && Array.isArray(response.data)) {
          this.vendors = response.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          // إذا كان الرد يحتوي على كائن بيانات
          this.vendors = response.data.data;
        } else {
          console.error('Invalid response format:', response.data);
          this.vendors = [];
        }
        
        this.currentPage = 1; // إعادة تعيين الترقيم
      } catch (error) {
        console.error('Error loading vendors:', error);
        this.vendors = [];
        if (error.response?.status === 401) {
          this.$router.push("/login");
        } else {
          //this.$toast.error("فشل في تحميل البيانات");
        }
      } finally {
        this.loading = false;
      }
    },
    
    // البحث بين التواريخ
    async get_vendors_by_dates() {
      if (!this.from || !this.to) {
        //this.$toast.warning("الرجاء اختيار تاريخ البداية والنهاية");
        return;
      }
      
      if (new Date(this.to) < new Date(this.from)) {
        //this.$toast.warning("تاريخ النهاية يجب أن يكون بعد تاريخ البداية");
        return;
      }
      
      this.loading = true;
      const token = localStorage.getItem("token");
      
      try {
        const payload = {
          from: this.from,
          to: this.to
        };
        
        const response = await this.$axios.post(
          "api/admin/904195-get-vendors-by-dates",
          payload,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        
        // التحقق من استجابة الـ API
        if (response.data && Array.isArray(response.data)) {
          this.vendors = response.data;
        } else if (response.data && response.data.data && Array.isArray(response.data.data)) {
          this.vendors = response.data.data;
        } else {
          console.error('Invalid response format:', response.data);
          this.vendors = [];
        }
        
        this.all = true;
        this.currentPage = 1;
        //this.$toast.success(`تم العثور على ${this.vendors.length} منفذ`);
      } catch (error) {
        console.error('Error searching by date:', error);
        this.vendors = [];
        if (error.response?.status === 401) {
          this.$router.push("/login");
        } else {
         // this.$toast.error("فشل في البحث بين التواريخ");
        }
      } finally {
        this.loading = false;
      }
    },
    
    // البحث بالاسم
    searchVendors() {
      this.currentPage = 1;
      // البحث يتم تلقائياً عبر computed property
    },
    
    // تحديد الكل
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedVendors = this.paginatedVendors.map(v => v.vendor_id);
      } else {
        this.selectedVendors = [];
      }
    },
    
    // تحويل القيم المنطقية
    fdevice(value) {
      return value === "true" || value === true || value === 1;
    },
    
    // تنسيق التاريخ
    formatDate(dateString) {
      if (!dateString) return '';
      try {
        const date = new Date(dateString);
        return date.toLocaleDateString('ar-EG', {
          year: 'numeric',
          month: 'long',
          day: 'numeric'
        });
      } catch (error) {
        return dateString;
      }
    },
    
    // تصدير إلى Excel
    async exportToExcel() {
      if (this.selectedVendors.length === 0) {
       // this.$toast.warning("الرجاء تحديد منفذ واحد على الأقل للتصدير");
        return;
      }
      
      this.exportLoading = true;
      
      try {
        const response = await this.$axios.post(
          "api/export-vendors",
          { vendor_ids: this.selectedVendors },
          { responseType: "blob" }
        );
        
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `منافذ_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
      //  this.$toast.success("تم التصدير بنجاح");
        this.verify = false;
        this.selectedVendors = [];
        this.selectAll = false;
      } catch (error) {
        console.error('Export error:', error);
        //this.$toast.error("فشل في التصدير");
      } finally {
        this.exportLoading = false;
      }
    },
    
    // تسجيل الخروج
    async logout() {
      this.logoutLoading = true;
      
      try {
        await this.$axios.get("api/admin/logout");
        localStorage.removeItem("token");
        this.$router.push("/login");
       // this.$toast.success("تم تسجيل الخروج بنجاح");
      } catch (error) {
        console.error('Logout error:', error);
       // this.$toast.error("فشل في تسجيل الخروج");
      } finally {
        this.logoutLoading = false;
      }
    },
    
    // تعيين الصور للعرض
    set_images(item) {
      this.target_item = {
        vendor_name: item.vendor_name,
        master: item.vendor_master_image || "",
        certificate: item.vendor_certificate_image || "",
        id_front: item.id_front || "",
        id_back: item.id_back || "",
        res_front: item.res_front || "",
        res_back: item.res_back || "",
          doc1: item.doc1 || "",
          doc2: item.doc2 || "",
          doc3: item.doc3 || ""
        
      };
      
      this.show_images = true;
    },
    
    // فتح تقرير المنفذ
    setVendorToReport(item) {
      const routeData = this.$router.resolve({
        name: 'report',
        params: { id: item.vendor_id }
      });
      window.open(routeData.href, '_blank');
    }
  },
  mounted() {
    this.get_vendors();
    
    // تعيين تواريخ افتراضية (آخر 7 أيام)
    const today = new Date();
    const lastWeek = new Date(today);
    lastWeek.setDate(today.getDate() - 7);
    
    this.to = today.toISOString().split('T')[0];
    this.from = lastWeek.toISOString().split('T')[0];
  }
};
</script>

<style scoped>
.h-screen {
  height: 100vh;
}

.h-100 {
  height: 100%;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.flex-grow-1 {
  flex-grow: 1;
}

/* تخصيص scrollbar للجدول */
.v-data-table ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.v-data-table ::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.v-data-table ::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.v-data-table ::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>